module.exports = __webpack_public_path__ + "static/media/heuritech_max.5aee2ac6.svg";